/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionPositionOverride
 */
export interface InputUavMissionPositionOverride {
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionPositionOverride
     */
    dir?: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionPositionOverride
     */
    dist: number;
}

/**
 * Check if a given object implements the InputUavMissionPositionOverride interface.
 */
export function instanceOfInputUavMissionPositionOverride(value: object): boolean {
    if (!('dist' in value)) return false;
    return true;
}

export function InputUavMissionPositionOverrideFromJSON(json: any): InputUavMissionPositionOverride {
    return InputUavMissionPositionOverrideFromJSONTyped(json, false);
}

export function InputUavMissionPositionOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionPositionOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'dir': json['dir'] == null ? undefined : json['dir'],
        'dist': json['dist'],
    };
}

export function InputUavMissionPositionOverrideToJSON(value?: InputUavMissionPositionOverride | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dir': value['dir'],
        'dist': value['dist'],
    };
}

